import { Navbar, TrackPlayer } from 'components/organisms';
import { Outlet } from 'react-router-dom';
import './ApplicationTemplate.scss';

const ApplicationTemplate = () => {
  return (
    <div className='application-template'>
      <div className='navbar'>
        <Navbar />
      </div>
      <div className='application-main'>
        <div className='application'>
          <Outlet />
        </div>
        <TrackPlayer />
      </div>
    </div>
  );
};

export default ApplicationTemplate;
